var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1.94595V1.51351H3.67568V3.02703H5.51351V4.64865H8.64865V3.02703H10.2703V1.51351H12V0H13.9459V1.62162H12.2162V3.13514H10.4865V4.64865H8.75676V7.13514H10.4865V8.75676H12.2162V10.2703H13.9459V12H12V10.3784H10.2703V8.86487H8.43243V7.24324H5.51351V8.86487H3.67568V10.3784H1.94595V12H0V10.2703H1.72973V8.75676H3.45946V7.13514H5.2973V4.64865H3.45946V3.13514H1.72973V1.62162H0V0Z",
    fill: "#2D303A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFilters);
export default __webpack_public_path__ + "static/media/reset_filters.73904b1c307c670312c1947abb989be4.svg";
export { ForwardRef as ReactComponent };